const { useContext } = require("react");
const { PackagesContext } = require("../context/PackageContext");
const { default: useBranch } = require("./useBranch");

const useTrialClass = () => {
  const { paquetes } = useContext(PackagesContext);
  const { branch_id } = useBranch();

  const class_package_id = branch_id === 1 ? 19304 : 19301;
  const trial_class_package = paquetes?.find(
    (paquete) => paquete.class_package_id === class_package_id
  );

  return { class_package_id, trial_class_package };
};

export default useTrialClass;